type Props = {
  keyword: string;
  defaultKeyword: string;
};

export function createRemotePrediction({ keyword, defaultKeyword }: Props) {
  const text =
    keyword.toLowerCase() === defaultKeyword.toLowerCase()
      ? keyword
      : `${keyword} (${defaultKeyword})`;
  return {
    placePrediction: {
      mainText: {
        text,
      },
      secondaryText: {
        text: '',
      },
      text: {
        text,
      },
      placeId: null,
    },
    isRemoteOption: true,
  };
}
